import React from 'react';
import { PaddedInfoIcon, Link } from './style';
import { InfoLinkProps } from './types';

const InfoLink = ({ link, linkText }: InfoLinkProps) => (
    <Link
        to={link}
    >
        {linkText}
        <PaddedInfoIcon />
    </Link>
);

export default InfoLink;
